'use client'

import { useRouter } from 'next/navigation'
import { X } from 'lucide-react'
import { REFERENCE_PRICE_LABEL } from '@/lib/pricing-display'
import { Z } from '@/lib/z-index'

interface UpgradeModalProps {
  open: boolean
  onClose: () => void
  onSignUp?: () => void
}

export default function UpgradeModal({ open, onClose, onSignUp }: UpgradeModalProps) {
  const router = useRouter()
  if (!open) return null

  const handlePayment = () => {
    onClose()
    // Payment Hub : pays/moyen choisis sur la page, email pré-rempli côté serveur
    // → aucun paramètre d'URL (et aucune donnée personnelle dans l'URL).
    router.push('/payment/hub')
  }

  return (
    <div
      style={{ position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.55)', zIndex: Z.modal, display: 'flex', alignItems: 'center', justifyContent: 'center', padding: 20 }}
      onClick={onClose}
    >
      <div
        style={{ background: '#fff', borderRadius: 16, padding: '32px 28px', width: '100%', maxWidth: 460, position: 'relative' }}
        onClick={e => e.stopPropagation()}
      >
        <button onClick={onClose} style={{ position: 'absolute', top: 16, right: 16, background: 'none', border: 'none', cursor: 'pointer', padding: 4 }}>
          <X size={20} color="#9CA3AF" />
        </button>

        <div style={{ textAlign: 'center', marginBottom: 24 }}>
          <div style={{ fontSize: 38, marginBottom: 12 }}>🎉</div>
          <h2 style={{ fontSize: 22, fontWeight: 800, color: '#111827', marginBottom: 8, margin: 0 }}>
            Vous avez adoré Qualyse&nbsp;!
          </h2>
          <p style={{ fontSize: 14, color: '#6B7280', lineHeight: 1.6, marginTop: 10 }}>
            Vous avez utilisé votre accès gratuit pour ce module.
          </p>
        </div>

        <div style={{ background: '#F0FAF4', borderRadius: 12, padding: '20px 24px', marginBottom: 20, border: '1px solid #c8e6d0' }}>
          <div style={{ fontSize: 11, fontWeight: 700, color: '#1B4332', letterSpacing: '0.06em', marginBottom: 14, fontFamily: 'monospace' }}>
            {/* Prix de référence UNIQUE (D-020). Le montant local réellement
                débité n'est révélé qu'au Payment Hub, après le choix du pays et
                du moyen de paiement — afficher ici « 13 100 XOF » exposait un
                marché figé dans un produit multi-pays. */}
            PLAN PRO — {REFERENCE_PRICE_LABEL.toUpperCase()}
          </div>
          {[
            { emoji: '🎙️', label: 'Transcription audio (illimitée)' },
            { emoji: '✏️', label: 'Correction verbatim (illimitée)' },
            { emoji: '🏷️', label: 'Codification thématique (illimitée)' },
            { emoji: '📋', label: 'Note Technique qualitative' },
            { emoji: '📊', label: "Rapport d'analyse qualitative" },
            { emoji: '📁', label: 'Export Word professionnel' },
            { emoji: '💳', label: '1 300 crédits/mois' },
          ].map(item => (
            <div key={item.label} style={{ display: 'flex', alignItems: 'center', gap: 10, marginBottom: 8, fontSize: 13, color: '#111827' }}>
              <div style={{ width: 18, height: 18, borderRadius: '50%', background: '#1B4332', display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0 }}>
                <svg width="10" height="10" viewBox="0 0 10 10" fill="none">
                  <path d="M2 5l2 2 4-4" stroke="white" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
                </svg>
              </div>
              <span style={{ fontSize: 14 }}>{item.emoji}</span>
              {item.label}
            </div>
          ))}
        </div>

        <button
          onClick={handlePayment}
          style={{ width: '100%', padding: '13px 0', borderRadius: 8, fontSize: 15, fontWeight: 700, color: '#fff', background: '#1B4332', border: 'none', cursor: 'pointer', marginBottom: 10 }}
        >
          🚀 Passer au Plan Pro
        </button>

        <button
          onClick={onClose}
          style={{ width: '100%', padding: '10px 0', borderRadius: 8, fontSize: 13, fontWeight: 500, color: '#6B7280', background: 'none', border: 'none', cursor: 'pointer' }}
        >
          Pas maintenant
        </button>
      </div>
    </div>
  )
}
